"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Visit = void 0;
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
const constants_1 = require("../../constants");
let Visit = class Visit extends mocks_1.Model {
};
exports.Visit = Visit;
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId, index: true }),
    __metadata("design:type", String)
], Visit.prototype, "patientId", void 0);
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId, index: true }),
    __metadata("design:type", String)
], Visit.prototype, "doctorId", void 0);
__decorate([
    (0, property_1.Property)({ type: String, enum: constants_1.VisitStatusEnum, index: true }),
    __metadata("design:type", String)
], Visit.prototype, "status", void 0);
__decorate([
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], Visit.prototype, "startedAt", void 0);
__decorate([
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], Visit.prototype, "endedAt", void 0);
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], Visit.prototype, "maxVisitDurationMinutes", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: '_id', foreignIdField: 'visitId', ref: 'Receipt' }),
    __metadata("design:type", Function)
], Visit.prototype, "receipt", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'patientId', ref: 'User' }),
    __metadata("design:type", Function)
], Visit.prototype, "patient", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'doctorId', ref: 'User' }),
    __metadata("design:type", Function)
], Visit.prototype, "doctor", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: '_id', foreignIdField: 'visitId', ref: 'Chat', isArray: true }),
    __metadata("design:type", Array)
], Visit.prototype, "chats", void 0);
exports.Visit = Visit = __decorate([
    (0, mocks_1.index)({ status: 1, patientId: 1 }),
    (0, mocks_1.index)({ patientId: 1, status: 1, _id: -1 }),
    (0, mocks_1.index)({ doctorId: 1, status: 1, _id: -1 })
], Visit);
